//import logo from './logo.svg';
import './App.css';


import 'bootstrap/dist/css/bootstrap.min.css';
import { NavBar } from "./components/NavBar";
import { Banner } from "./components/Banner";
import { Skills } from "./components/Skills";
import { Projects } from "./components/Projects";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { ServicesSection } from "./components/ServicesSection";
import { ServiceDetails } from './components/ServiceDetails';
//import ContactForm from './components/Contactme';
//import { Helmet } from "react-helmet";
//import cover from "./assets/img/palawan-freelancer-cover.jpg";
//import OGMeta from './components/OgMeta';
//import TitleBar from './components/TitleBar';



// import FirstSection from './components/test';
// import SecondSection from './components/test2';

function App() {
  return (
    <div className="App">

  
  {/* <TitleBar /> */}
      {/* <Helmet>
    
          <meta name="description" content="Professional web development services in Palawan. Specializing in responsive website design and custom web applications." />
          <meta name="keywords" content="web design Palawan,web developer Palawan, Software developer Palawan, Mobile app developer Palawan, Custom web design Palawan, Responsive web design Palawan, Professional web development Palawan, Custom software development Palawan, Mobile app development Palawan,Android app development Palawan" />
          <meta name="robots" content="all" />
          <title>Web Developer in Palawan | Website Design and Development Services</title>
      </Helmet> */}
      {/* <OGMeta 
        title="Web Design and Development Services"
        type="website"
        image={cover}
        url=""
        description="Professional web development services in Palawan. Specializing in responsive website design and custom web applications. Multi-Level Marketing (MLM), E-Commerce, Mobile Application, Software"
      /> */}

      <NavBar />
      <Banner />
 
      <ServiceDetails />
      <ServicesSection />
      
      {/* <FirstSection />
      <SecondSection /> */}
      <Projects />
      <Skills />
      {/* <ContactForm /> */}
      <Contact />
      <Footer />
    </div>
  );
}

export default App;